export var SLOT_PREVIEW_STATE;
(function (SLOT_PREVIEW_STATE) {
    SLOT_PREVIEW_STATE["HIGHLIGHTED"] = "highlighted";
})(SLOT_PREVIEW_STATE || (SLOT_PREVIEW_STATE = {}));
//# sourceMappingURL=constants.js.map